import { Box } from '@atlaskit/primitives';
import SectionMessage from '@atlaskit/section-message';
import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

export const InstallationSuccess: React.FC = () => {
    const history = useHistory();

    useEffect(() => {
        // Auto-close after 10 seconds
        const timer = setTimeout(() => {
            window.close();
        }, 10000);

        return () => clearTimeout(timer);
    }, [history]);

    return (
        <Box style={{ 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center', 
            height: '100vh'
        }}>
            <SectionMessage appearance="success">
                <h3>Installation Successful! 🎉</h3>
                <p>The Rovo app has been successfully installed. This window can be closed or will close automatically in few seconds.</p>
            </SectionMessage>
        </Box>
    );
};
